/**
 * Centralized Configuration
 * Tất cả config URL nằm ở đây
 */

// API Backend URL FOR TESTING LOCAL
//export const API_BASE_URL = 'http://localhost:3333';

// Frontend Public URL (for QR codes, sharing links)
// Dùng IP cố định để mobile có thể truy cập qua mạng LAN
//export const FRONTEND_BASE_URL = 'http://192.168.1.8:8000';

// API Backend URL FOR PRODUCTION SERVER
// Gọi qua nginx reverse proxy
export const API_BASE_URL = '/api';

// Frontend Public URL (QR code, share link)
// Tự lấy domain/IP + port hiện tại (LAN, prod, domain đều đúng)
export const FRONTEND_BASE_URL =
  typeof window !== 'undefined' ? window.location.origin : '';


// Config object for easy import
const config = {
  api: {
    baseUrl: API_BASE_URL,
    timeout: 30000,
  },
  frontend: {
    baseUrl: FRONTEND_BASE_URL,
  },
  // Public routes that don't require authentication
  publicPaths: [
    '/queue',
    '/qr-queue',
    '/m-queue',
    '/tv',
    '/counter',
    '/user/login',
    '/user/register',
    '/user/register-result',
  ],
  // API endpoints that don't need Authorization header
  noAuthEndpoints: ['/auth/login', '/auth/register', '/public/'],
};

export default config;
